import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Card, ListGroup, Spinner } from 'react-bootstrap-5';
import Ownership from './ownership';
import { connect } from 'react-redux';
import { setOwners } from '../store/actions/owners';

function Owners({ owners, setOwners }) {
  useEffect(() => {
    setOwners();
  }, []);

  return (
    <Card>
      <Card.Header>
        <h5 className="fw-bolder mb-0">Owners</h5>
      </Card.Header>

      {!owners && (
        <Card.Body className="text-center">
          <Spinner animation="border" variant="secondary" />
        </Card.Body>
      )}
      <ListGroup variant="flush">
        {owners && owners.map((owner, i) => (
          <Ownership
            index={i}
            key={owner.id}
            owner={owner}
          />
        ))}
      </ListGroup>
    </Card>
  );
}

Owners.propTypes = {
  owners: PropTypes.array,
  setOwners: PropTypes.func.isRequired,
};

const mapStateToProps = ({ owners }) => ({ owners });
export default connect(mapStateToProps, { setOwners })(Owners);
